document.addEventListener("DOMContentLoaded", function () {
    Shopify.formatMoney = function(cents, format) {
        if (typeof cents == "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /{{\s*(\w+)\s*}}/;
        var formatString = (format || this.money_format);

        function defaultOption(opt, def) {
            return (typeof opt == "undefined" ? def : opt);
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ",");
            decimal = defaultOption(decimal, ".");
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
        }
        return formatString.replace(placeholderRegex, value);
    };

    // Example usage:
    var priceInCents = 12345; // 123.45 in the store currency
    var formatted = Shopify.formatMoney(priceInCents, Shopify.money_format);
    // formatted will be "$123.45" or as per your shop's money_format setting

    /* -----------------------------
       STEP NAVIGATION 
    ------------------------------*/
    const tabs = document.querySelectorAll(".addon-tab");
    const navBtns = document.querySelectorAll(".addon-nav-btn");

    function showTab(id) {
        tabs.forEach(t => t.classList.remove("active"));
        navBtns.forEach(b => b.classList.remove("active"));

        document.querySelector(`.addon-tab[data-tab-id="${id}"]`).classList.add("active");
        document.querySelector(`.addon-nav-btn[data-tab-id="${id}"]`).classList.add("active");
    }

    document.querySelectorAll(".next-step").forEach(btn => {
        btn.addEventListener("click", () => {
            const parent = btn.closest(".addon-tab");
            const id = Number(parent.dataset.tabId) + 1;
            showTab(id);
        });
    });

    document.querySelectorAll(".prev-step").forEach(btn => {
        btn.addEventListener("click", () => {
            const parent = btn.closest(".addon-tab");
            const id = Number(parent.dataset.tabId) - 1;
            showTab(id);
        });
    });

    /* ======================================================
    STEP 1 — QUANTITY & PRICE
    ====================================================== */

    const step1 = document.querySelector('.addon-tab[data-tab-id="1"]');
    const qtyInput = step1.querySelector('input[name="quantity"]');
    const step1PriceBox = step1.querySelector(".price-value");
    const step1UnitPrice = Number(step1.dataset.productPrice);
    const main_prd_id = Number(step1.dataset.productId);

    const step2 = document.querySelector('.addon-tab[data-tab-id="2"]');
    const accInput = step2.querySelector('input[name="quantity"]');
    const step2PriceBox = step2.querySelector(".price-value");
    const step2UnitPrice = Number(step2.dataset.productPrice);
    const acc_free_id = Number(step2.dataset.accountfId);
    const acc_id = Number(step2.dataset.accountId);

    const step3 = document.querySelector('.addon-tab[data-tab-id="3"]');
    const step3PriceBox = step3.querySelector(".price-value");

    const step3RepeatContainer = step3.querySelector(".variation-wrapper");
    const variationWrapperTemplate = step3.querySelector(".variation-group");

    function updateStep1Price() {
        const qty = Math.max(1, Number(qtyInput.value));
        qtyInput.value = qty;

        const newPrice = qty * step1UnitPrice;
        step1PriceBox.textContent = Shopify.formatMoney(newPrice, Shopify.money_format);

        // 💥 Sync Step 2 quantity + minimum
        accInput.min = qty;
        accInput.value = qty;
        if (Number(accInput.value) < qty) {
            // accInput.classList.add('');
            step2.querySelector(`button[name="minus"]`).classList.add('disabled');
        }

        updateStep2Price();
        renderStep3();
    }

    // Step 1 plus/minus
    ["plus", "minus"].forEach(name => {
        step1.querySelector(`button[name="${name}"]`)
            .addEventListener("click", updateStep1Price);
    });

    qtyInput.addEventListener("input", updateStep1Price);



    /* ======================================================
        STEP 2 — ACCOUNTS & PRICE
    ====================================================== */



    function updateStep2Price() {

        // minimum based on step1
        const step1Qty = Number(qtyInput.value);
        let accQty = Math.max(step1Qty, Number(accInput.value));
        accInput.value = accQty;

        const step1Total = step1Qty * step1UnitPrice;
        let finalPrice = step1Total;

        // 💥 Additional price only above Step-1 qty
        if (accQty > step1Qty) {
            const extra = accQty - step1Qty;
            finalPrice += extra * step2UnitPrice;
        }else{
            step2.querySelector(`button[name="minus"]`).classList.add('disabled');
        }

        step2PriceBox.textContent = Shopify.formatMoney(finalPrice, Shopify.money_format);
    }

    // Step 2 plus/minus
    ["plus", "minus"].forEach(name => {
        step2.querySelector(`button[name="${name}"]`)
            .addEventListener("click", () => {
                updateStep2Price();
                renderStep3();
            });
    });

    accInput.addEventListener("input", () => {
        updateStep2Price();
        renderStep3();
    });

    // Initialize prices on load
    updateStep1Price();
    updateStep2Price();



    /* ======================================================
        STEP 3 — CLONE VARIATION WRAPPER
    ====================================================== */





    function renderStep3() {
        const step1Qty = Number(qtyInput.value);
        const accQty = Number(accInput.value);

        const step1Total = step1Qty * step1UnitPrice;
        let finalPrice = step1Total;

        // 💥 Extra price above Step-1 qty
        if (accQty > step1Qty) {
            finalPrice += (accQty - step1Qty) * step2UnitPrice;
        }

        step3PriceBox.textContent = Shopify.formatMoney(finalPrice, Shopify.money_format);

        // Clear current clones
        step3RepeatContainer.innerHTML = "";

        // 💥 Number of clones = step2 qty - step1 qty
        const extra = accQty;

        for (let i = 1; i <= extra; i++) {
            const clone = variationWrapperTemplate.cloneNode(true);
            clone.classList.add("clone-item");
            clone.querySelectorAll('input').forEach(function(e){
                e.setAttribute('name', 'free_socks['+i+']')
            })
            clone.dataset.index = i;
            step3RepeatContainer.appendChild(clone);
        }

        validateStep3Selection();
    }

    // When moving from Step 2 → Step 3
    document.querySelectorAll(".next-step").forEach(btn => {
        btn.addEventListener("click", () => {
            const current = btn.closest(".addon-tab");
            if (current.dataset.tabId === "2") {
                renderStep3();
            }
        });
    });


    function validateStep3Selection() {
        const wrappers = step3RepeatContainer.querySelectorAll(".clone-item");
        const addBtn = step3.querySelector(".finish-order");

        let allSelected = true;

        wrappers.forEach(wrapper => {
            const selected = wrapper.querySelector("input[type='radio']:checked");
            if (!selected) {
                allSelected = false;
            }
        });

        if (allSelected) {
            addBtn.classList.remove("disabled");
            addBtn.removeAttribute("disabled");
        } else {
            addBtn.classList.add("disabled");
            addBtn.setAttribute("disabled", true);
        }
    }

    step3RepeatContainer.addEventListener("change", function(e) {
        if (e.target.type === "radio") {
            validateStep3Selection();
        }
    });

    function collectStep3Selections() {
        const step1Qty = Number(qtyInput.value);
        const accQty = Number(accInput.value);

        // your variant IDs (replace with actual Shopify variant IDs)
        const MAIN_VARIANT_ID = main_prd_id;   // Step-1 product
        const EXTRA_VARIANT_ID = acc_id;  // Extra Step-2 product

        const list = [];

        const wrappers = step3RepeatContainer.querySelectorAll(".clone-item");

        wrappers.forEach((wrapper, index) => {
            const selected = wrapper.querySelector("input[type='radio']:checked");

            if (selected) {
                const sizeValue = selected.dataset.name;

                // First N belong to Step-1 qty → main variant
                const isMain = index < step1Qty;

                list.push({
                    variant_id: isMain ? MAIN_VARIANT_ID : EXTRA_VARIANT_ID,
                    size: sizeValue
                });
            }
        });

        return list;
    }

    function prepareCartItems() {

        const step1Qty = Number(qtyInput.value);      // main qty
        const accQty = Number(accInput.value);        // total accounts

        const extraQty = accQty - step1Qty;           // extra accounts

        // Product Variant IDs
        const MAIN_VARIANT_ID      = main_prd_id;        // main product
        const FREE_ACCOUNT_ID      = acc_free_id;    // free account product
        const EXTRA_ACCOUNT_ID     = acc_id;             // paid account product

        let items = [];

        // All sock selections by order
        const wrappers = step3RepeatContainer.querySelectorAll(".clone-item");

        let sockIndex = 0;

        /* ============================================================
            LOOP THROUGH EACH ACCOUNT SLOT (first main_qty → main)
        =============================================================== */

        for (let i = 0; i < accQty; i++) {

            const isMain = i < step1Qty;

            // Get this sock selection
            const sockWrapper = wrappers[sockIndex];
            const selectedSock = sockWrapper.querySelector("input[type='radio']:checked");

            const sockVariantID = Number(selectedSock.value);
            const sockSize      = selectedSock.dataset.name;
            const sockVariantName = selectedSock.dataset.variantName;
            let random_id = Math.floor(Math.random() * 10000);

            /* -----------------------------------------
                    A) MAIN PRODUCT
            ------------------------------------------ */
            if (isMain) {

                // 1) Main product
                items.push({
                    id: MAIN_VARIANT_ID,
                    quantity: 1,
                    properties: {
                        "+ Account": "(Free of charge)",
                        "+ 4KICKERZ HYPER GRIP SOCKS - Free of charge": sockSize
                        // "_free_key": random_id
                    }
                });

                // 2) Free Account
                // items.push({
                //     id: FREE_ACCOUNT_ID,
                //     quantity: 1,
                //     properties: {
                //         "_item_key": random_id
                //     }
                // });

                // // 3) Sock for main product
                // items.push({
                //     id: sockVariantID,
                //     quantity: 1,
                //     properties: {
                //         "_item_key": random_id
                //     }
                // });
            }

            /* -----------------------------------------
                    B) EXTRA ACCOUNT
            ------------------------------------------ */
            else {

                // 1) Extra Account
                items.push({
                    id: EXTRA_ACCOUNT_ID,
                    quantity: 1,
                    properties: {
                        "+ 4KICKERZ HYPER GRIP SOCKS - Free of charge": sockSize
                        // "_free_key": random_id
                    }
                });

                // 2) Sock for extra account
                // items.push({
                //     id: sockVariantID,
                //     quantity: 1,
                //     properties: {
                //         "_item_key": random_id
                //     }
                // });
            }

            sockIndex++;
        }

        return items;
    }


    document.querySelector(".finish-order").addEventListener("click", (e) => {
        e.currentTarget.classList.add("loading");
        let result = prepareCartItems();
        result = convertToShopifyItemsFormat(result);
        addMultipleItemsToCart(result)
        console.log("FINAL VARIANT DATA:", result);

        // TODO → send result to AJAX cart or Shopify cart form
    });

    function convertToShopifyItemsFormat(rawItems) {
        return {
            items: rawItems.map(item => ({
            id: item.id,
            quantity: item.quantity,
            properties: item.properties || {}
            }))
        };
    }


    async function addMultipleItemsToCart(items) {
        const CART_ADD_URL = "/cart/add.js";

        const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");

        items.items.reverse();
        const payload = items;

        let sectionIds = [];

        if (cart) {
            try {
                sectionIds = cart.getSectionsToRender().map(s => s.id);
                payload.sections = sectionIds;
                payload.sections_url = window.location.pathname;
            } catch (e) {
                console.warn("Could not get sections:", e);
            }
        }

        try {
            const response = await fetch(CART_ADD_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.status) {
                console.error("Shopify Error:", data.description);
                return { success: false, error: data.description };
            }

            // ---- Try refreshing the cart drawer with multiple fallbacks ----
            if (cart) {
                const updated = await refreshCartDrawer(cart, data, sectionIds);
                if (!updated) {
                    console.warn("All drawer refresh methods failed — updating cart count only");
                    await updateCartBubbleOnly();
                }
            } else {
                // No drawer element at all — just update the cart icon count
                await updateCartBubbleOnly();
            }

            return { success: true, data };

        } catch (err) {
            console.error("Failed to add items:", err);
            // Items ARE added to cart even if UI fails — just refresh the count
            await updateCartBubbleOnly();
            return { success: false, error: err };
        }
    }


    // =============================================
    // MULTI-LAYER CART DRAWER REFRESH
    // =============================================
    async function refreshCartDrawer(cart, data, sectionIds) {

        // ---- METHOD 1: Direct renderContents (normal Shopify way) ----
        const hasSections = data.sections &&
            Object.keys(data.sections).length > 0 &&
            Object.values(data.sections).every(v => v !== null);

        if (hasSections) {
            try {
                cart.renderContents(data);
                console.log("Cart updated via METHOD 1: renderContents");
                return true;
            } catch (e) {
                console.warn("METHOD 1 failed:", e);
            }
        }

        // ---- METHOD 2: Fetch sections manually via Section Rendering API ----
        if (sectionIds.length > 0) {
            try {
                const sectionsParam = sectionIds.join(",");
                const res = await fetch(`${window.location.pathname}?sections=${sectionsParam}`);
                const sectionsData = await res.json();

                data.sections = sectionsData;
                cart.renderContents(data);
                console.log("Cart updated via METHOD 2: manual sections fetch");
                return true;
            } catch (e) {
                console.warn("METHOD 2 failed:", e);
            }
        }

        // ---- METHOD 3: Fetch from /cart page and extract sections ----
        try {
            const res = await fetch("/cart");
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const remoteDrawer = doc.querySelector("#shopify-section-cart-drawer") ||
                                doc.querySelector("[id*='cart-drawer']");

            const localDrawer = document.querySelector("#shopify-section-cart-drawer") ||
                                document.querySelector("[id*='cart-drawer']");

            if (remoteDrawer && localDrawer) {
                localDrawer.innerHTML = remoteDrawer.innerHTML;
                console.log("Cart updated via METHOD 3: /cart page HTML swap");
                // Re-open the drawer after swapping
                openCartDrawer();
                return true;
            }
        } catch (e) {
            console.warn("METHOD 3 failed:", e);
        }

        // ---- METHOD 4: Dispatch Shopify native events to trigger theme refresh ----
        try {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document.dispatchEvent(new CustomEvent("cart:build"));

            // Also try the common theme event patterns
            if (typeof window.Shopify !== "undefined" && window.Shopify.theme) {
                document.dispatchEvent(new CustomEvent("shopify:section:load"));
            }

            // Programmatically click the cart icon to force drawer open with fresh data
            const cartIcon = document.querySelector('a[href="/cart"]') ||
                            document.querySelector('.cart-icon-bubble') ||
                            document.querySelector('[data-cart-toggle]') ||
                            document.querySelector('cart-icon-bubble');

            if (cartIcon) {
                cartIcon.click();
                console.log("Cart updated via METHOD 4: dispatched events + cart icon click");
                return true;
            }
        } catch (e) {
            console.warn("METHOD 4 failed:", e);
        }

        return false;
    }


    // =============================================
    // HELPER: Open cart drawer after DOM swap
    // =============================================
    function openCartDrawer() {
        try {
            const drawer = document.querySelector("cart-drawer");
            if (drawer) {
                // Try Shopify Dawn theme method
                if (typeof drawer.open === "function") {
                    drawer.open();
                } else {
                    // Fallback: toggle the open attribute
                    drawer.classList.add("is-open", "active");
                    drawer.setAttribute("open", "");
                    const overlay = drawer.querySelector(".drawer__overlay");
                    if (overlay) overlay.click(); // some themes need this
                }
            }
        } catch (e) {
            console.warn("Could not auto-open drawer:", e);
        }
    }


    // =============================================
    // LAST RESORT: Just update the cart item count
    // =============================================
    async function updateCartBubbleOnly() {
        try {
            const res = await fetch("/cart.js", {
                headers: { "Accept": "application/json" }
            });
            const cartData = await res.json();
            const count = cartData.item_count;

            // Update every possible cart count element on the page
            const selectors = [
                ".cart-count",
                ".cart-count-bubble span",
                "[data-cart-count]",
                ".cart-icon-bubble span",
                "#cart-icon-bubble span",
                ".header__cart-count",
                ".js-cart-count"
            ];

            selectors.forEach(sel => {
                document.querySelectorAll(sel).forEach(el => {
                    el.textContent = count;
                });
            });

            // Make the bubble visible if it was hidden
            const bubble = document.querySelector(".cart-count-bubble") ||
                        document.querySelector("[data-cart-count-bubble]");
            if (bubble) {
                bubble.style.display = "";
                bubble.removeAttribute("hidden");
            }

            console.log(`Cart bubble updated: ${count} items`);
        } catch (e) {
            console.warn("Cart bubble update failed:", e);
        }
    }
});